import { useRef as e, useLayoutEffect as r } from "react";

import o from "../../../hooks/useId/index.js";

import t from "../models/basic.js";

const s = ({labelId: s, ...d}) => {
    const i = o(), m = e().current ||= new t({
        idPrefix: i,
        labelId: s
    }).set(d);
    return r((() => {
        m.set(d);
    })), m;
};

export { s as default };
//# sourceMappingURL=useModel.js.map
